import { VisitedJob } from 'components/jobteaser/JobTeaser';
import { useEffect } from 'react';

const useCleanUpVisitedJobs = (
  newThresholdHours: string,
  visitedJobs: VisitedJob[],
  setVisitedJobs: React.Dispatch<React.SetStateAction<VisitedJob[]>>,
) => {
  useEffect(() => {
    const cleanupVisitedJobs = () => {
      const now = new Date().getTime();
      const thresholdMs = parseInt(newThresholdHours, 10) * 60 * 60 * 1000;
      const updatedVisitedJobs = visitedJobs?.filter((job) => {
        const jobAge = now - new Date(job.createdAt).getTime();
        return jobAge < thresholdMs;
      });

      if (updatedVisitedJobs.length !== visitedJobs.length) {
        setVisitedJobs(updatedVisitedJobs);
      }
    };

    cleanupVisitedJobs();
  }, []);
};

export default useCleanUpVisitedJobs;
